const A = "/assets/";
const H = 768;

export const CUSTOMERS = {
  young_man_nordic: {
    label: { en: "Young man 1", fi: "Nuori mies 1" }, name: "Lukas", portrait: `${A}portrait_young_man_nordic.png`,
    sprite: { frames: [`${A}walk_young_man_nordic_0.png`, `${A}walk_young_man_nordic_1.png`], aspect: 515 / H },
  },
  young_man_aa: {
    label: { en: "Young man 2", fi: "Nuori mies 2" }, name: "Malik", portrait: `${A}portrait_young_man_aa.png`,
    sprite: { frames: [`${A}walk_young_man_aa_0.png`, `${A}walk_young_man_aa_1.png`], aspect: 374 / H },
  },
  young_woman_nordic: {
    label: { en: "Young woman 1", fi: "Nuori nainen 1" }, name: "Freja", portrait: `${A}portrait_young_woman_nordic.png`,
    sprite: { frames: [`${A}walk_young_woman_nordic_0.png`, `${A}walk_young_woman_nordic_1.png`], aspect: 399 / H },
  },
  young_woman_asian: {
    label: { en: "Young woman 2", fi: "Nuori nainen 2" }, name: "Mei", portrait: `${A}portrait_young_woman_asian.png`,
    sprite: { frames: [`${A}walk_young_woman_asian_0.png`, `${A}walk_young_woman_asian_1.png`], aspect: 370 / H },
  },
  middle_man_nordic: {
    label: { en: "Middle-aged man 1", fi: "Keski-ikäinen mies 1" }, name: "Matti", portrait: `${A}portrait_middle_man_nordic.png`,
    sprite: { frames: [`${A}walk_middle_man_nordic_0.png`, `${A}walk_middle_man_nordic_1.png`], aspect: 401 / H },
  },
  middle_woman_italian: {
    label: { en: "Middle-aged woman 1", fi: "Keski-ikäinen nainen 1" }, name: "Giulia", portrait: `${A}portrait_middle_woman_italian.png`,
    sprite: { frames: [`${A}walk_middle_woman_italian_0.png`, `${A}walk_middle_woman_italian_1.png`], aspect: 394 / H },
  },
  old_man_nordic: {
    label: { en: "Old man 1", fi: "Iäkäs mies 1" }, name: "Eero", portrait: `${A}portrait_old_man_nordic.png`,
    sprite: { frames: [`${A}walk_old_man_nordic_0.png`, `${A}walk_old_man_nordic_1.png`], aspect: 380 / H },
  },
  old_woman_nordic: {
    label: { en: "Old woman 1", fi: "Iäkäs nainen 1" }, name: "Kerttu", portrait: `${A}portrait_old_woman_nordic.png`,
    sprite: { frames: [`${A}walk_old_woman_nordic_0.png`, `${A}walk_old_woman_nordic_1.png`], aspect: 335 / H },
  },
};

export const CUSTOMER_ORDER = Object.keys(CUSTOMERS);

export const grumpyPortrait = (type) => `${A}portrait_grumpy_${type}.png`;

export const BACKGROUNDS = {
  default: { label: { en: "General store", fi: "Yleismyymälä" }, src: null },
  av: { label: { en: "AV / TV department", fi: "AV-osasto" }, src: `${A}store_bg_av.jpg` },
  white_goods: { label: { en: "White goods", fi: "Kodinkoneet" }, src: `${A}store_bg_white.jpg` },
  mobile: { label: { en: "Mobile phones", fi: "Puhelinosasto" }, src: `${A}store_bg_mobile.jpg` },
};
export const BACKGROUND_ORDER = Object.keys(BACKGROUNDS);
export const bgSrc = (key) => BACKGROUNDS[key]?.src || null;

export const SHIRT_PRESETS = ["#2c397e", "#f3f1f2", "#a70618", "#29282d", "#ccb3d0"];

const hexToRgb = (h) => { const n = parseInt(h.slice(1), 16); return [n >> 16, (n >> 8) & 255, n & 255]; };

export const nearestShirt = (shirt) => {
  const c = hexToRgb((shirt || SHIRT_PRESETS[0]).toLowerCase());
  let best = SHIRT_PRESETS[0], bd = Infinity;
  for (const p of SHIRT_PRESETS) {
    const [r, g, b] = hexToRgb(p);
    const d = (r - c[0]) ** 2 + (g - c[1]) ** 2 + (b - c[2]) ** 2;
    if (d < bd) { bd = d; best = p; }
  }
  return best;
};

export const salesmanSprite = (shirt) => ({
  frames: [`${A}salesman_${nearestShirt(shirt).slice(1)}.png`], aspect: 237 / H,
});

let preloaded = false;
export const preloadSprites = () => {
  if (preloaded || typeof window === "undefined") return;
  preloaded = true;
  const urls = [];
  Object.entries(CUSTOMERS).forEach(([type, c]) => { urls.push(...c.sprite.frames, c.portrait, grumpyPortrait(type)); });
  BACKGROUND_ORDER.forEach((k) => { const s = bgSrc(k); if (s) urls.push(s); });
  SHIRT_PRESETS.forEach((c) => urls.push(`${A}salesman_${c.slice(1)}.png`));
  urls.forEach((u) => { const img = new Image(); img.src = u; });
};
